import type {DatePickerInputProps} from '@mantine/dates';
import {DatePickerInput} from '@mantine/dates';
import React from 'react';

export type DateRangePickerProps = Omit<DatePickerInputProps<'range'>, 'type'>;

/**
 * Calendar-day range input — design-layer pass-through over Mantine `DatePickerInput type="range"`.
 * @registry Pass-through Mantine DatePickerInput (range); import this instead of @mantine/dates outside src/design.
 */
export const DateRangePicker: React.FC<DateRangePickerProps> = props => (
  <DatePickerInput<'range'> {...props} type="range" />
);
